<nav class="d-flex flex-column navbar-light justify-content-around float-left" style="background:#FFFFFF ">
  <img class="logoDIP homeB d-flex align-self-center" routerLink="" type="button" [src]="logoEquipe">
  <h4 class="d-flex align-self-center text-center">{{welcome}}</h4>
  <div>
    @for (item of navigation; track item) {
      <div *kaHasRoles="[item.role]; checkRealm: true">
        <div id="{{item.label.replace(' ','-').toLowerCase()}}">
          <a class="d-flex flex-row align-items-center catdiv"
             [routerLink]="item.route" type="button"
             style="text-decoration: none; color: inherit;">
            <img class="link-image" style="margin-right: 5%" [src]="chemimagecard + item.label + '.png'">
            <h5 [id]="globalService.checkRoute('/'+item.label.replace(' ','-').toLowerCase())" class="link d-flex align-self-center">{{ 'menu-' + item.label.replace(' ', '-').toLowerCase() | translate }}</h5>
          </a>
          @if (item.label !== 'Black List') {
            <hr class="navbarhr">
          }
        </div>
      </div>
    }
  </div>
  <img class="logoW d-flex align-self-center" [src]="logoWorldline">
</nav>